export default "__VITE_ASSET__8O3OOqB$__"